import React from 'react';
import { Box, Chip, alpha, useTheme } from '@mui/material';

const ACCENT = '#137274';

/**
 * Horizontal language picker for the online IDE.
 */
const CompilerLanguagePicker = ({ languages, value, onChange, size = 'medium' }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const border = isDark ? '#30363d' : 'rgba(15, 60, 70, 0.12)';

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.75,
        p: size === 'compact' ? 0 : 0.25,
      }}
    >
      {languages.map((lang) => {
        const selected = lang.id === value;
        return (
          <Chip
            key={lang.id}
            label={size === 'compact' ? lang.shortLabel : lang.label}
            clickable
            onClick={() => onChange(lang.id)}
            size={size === 'compact' ? 'small' : 'medium'}
            sx={{
              fontWeight: selected ? 800 : 600,
              fontSize: size === 'compact' ? '0.72rem' : '0.8rem',
              height: size === 'compact' ? 26 : 32,
              borderRadius: 1.5,
              border: `1px solid ${selected ? ACCENT : border}`,
              bgcolor: selected
                ? alpha(ACCENT, isDark ? 0.28 : 0.12)
                : isDark
                  ? alpha('#fff', 0.03)
                  : '#fff',
              color: selected ? ACCENT : 'text.primary',
              '&:hover': {
                bgcolor: selected
                  ? alpha(ACCENT, isDark ? 0.32 : 0.16)
                  : alpha(ACCENT, isDark ? 0.12 : 0.06),
                borderColor: ACCENT,
              },
            }}
          />
        );
      })}
    </Box>
  );
};

export default CompilerLanguagePicker;
